import { useLDClient } from 'launchdarkly-react-client-sdk';

export const useEnableAllBarcodeSymbologies = (): boolean => {
  const ldClient = useLDClient();
  return ldClient?.variation('pos.mobile-checkout.enable-all-barcode-symbologies', false);
};
